import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FirmMemberFormValues } from './FirmMemberForm';
import { Input, InputProps, validateOptionalUrl } from './Form';
import { RegisterOptions, useFormContext } from 'react-hook-form';

interface FirmMemberCalendarSchedulingLinkInputProps extends Pick<InputProps, 'className' | 'trailing'> {
  inputProps?: InputProps['inputProps'];
  registerOptions?: RegisterOptions<FirmMemberFormValues, 'calendarSchedulingLink'>;
}

export const FirmMemberCalendarSchedulingLinkInput: FC<FirmMemberCalendarSchedulingLinkInputProps> = ({
  trailing,
  className,
  inputProps,
  registerOptions,
}) => {
  const { t: tForm } = useTranslation('form');
  const { register, formState } = useFormContext<FirmMemberFormValues>();

  return (
    <Input
      trailing={trailing}
      className={className}
      inputProps={{ ...inputProps }}
      label={tForm('firm-member-calendar-scheduling-link-input-label')}
      status={formState.errors.calendarSchedulingLink ? 'errored' : 'normal'}
      {...register('calendarSchedulingLink', { validate: (url) => validateOptionalUrl(url), ...registerOptions })}
    />
  );
};
